// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"ChangePassword_fieldset__2FYca"};